import React, { useRef, useState } from "react";

// Plays uploaded video files or a YouTube fallback.
// Shows ONLY the poster image (no visible play button); click anywhere to play.
export default function VideoPlayer({ src, poster, youtubeId, title = "Video", className = "" }) {
  const videoRef = useRef(null);
  const [started, setStarted] = useState(false);

  const posterSrc =
    poster || (youtubeId ? `https://img.youtube.com/vi/${youtubeId}/maxresdefault.jpg` : null);

  const play = () => {
    if (started) return;
    setStarted(true);
    setTimeout(() => videoRef.current?.play().catch(() => {}), 0);
  };

  // Uploaded video file (or nothing but poster)
  if (src || !youtubeId) {
    return (
      <div
        className={`relative aspect-video overflow-hidden ring-1 ring-white/10 bg-black ${src ? "cursor-pointer" : ""} ${className}`}
        onClick={src ? play : undefined}
        data-testid="video-player"
      >
        {src && (
          <video
            ref={videoRef}
            src={src}
            controls={started}
            playsInline
            preload="none"
            className={`absolute inset-0 w-full h-full object-contain bg-black transition-opacity duration-300 ${started ? "opacity-100" : "opacity-0"}`}
          />
        )}
        {!started && posterSrc && (
          <img
            src={posterSrc}
            alt={title}
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover"
          />
        )}
        {!started && !posterSrc && (
          <div className="absolute inset-0 flex items-center justify-center text-[color:var(--jk-muted)] text-xs font-cinzel tracking-widest">
            VIDEO COMING SOON
          </div>
        )}
      </div>
    );
  }

  // YouTube fallback — poster only, plays inline on click, no visible button
  return (
    <div
      className={`relative aspect-video overflow-hidden ring-1 ring-white/10 bg-black cursor-pointer ${className}`}
      onClick={() => setStarted(true)}
      data-testid="video-player"
    >
      {started ? (
        <iframe
          className="absolute inset-0 w-full h-full"
          src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <img src={posterSrc} alt={title} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
      )}
    </div>
  );
}
